var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    {
      staticClass: "access-denied-background ta-c",
      attrs: { justify: "center" },
    },
    [
      _c("v-col", { attrs: { cols: "12" } }, [
        _c("img", {
          staticClass: "access-denied",
          attrs: { src: _vm.ic_access_denied },
        }),
      ]),
      _c("v-col", { attrs: { cols: "12" } }, [
        _c("label", { staticClass: "header" }, [_vm._v("We’re Sorry...")]),
      ]),
      _c(
        "v-col",
        { attrs: { xl: "4", lg: "5", md: "7", sm: "10", xs: "10" } },
        [
          _c("label", { staticClass: "text" }, [
            _vm._v(
              "The page you’re trying to access is restricted. If you feel this is a mistake please get in touch with our support team at "
            ),
          ]),
          _c(
            "a",
            { staticClass: "link", attrs: { href: "tel:318-798-2111" } },
            [_vm._v("318-798-2111")]
          ),
          _c("label", { staticClass: "text" }, [_vm._v(" or email us at ")]),
          _c(
            "a",
            {
              staticClass: "link",
              attrs: { href: "mailto:TMSSupport@afs.net" },
            },
            [_vm._v("Customer Service Department")]
          ),
          _c("label", { staticClass: "text" }, [_vm._v(". ")]),
        ]
      ),
      _c(
        "v-col",
        { staticClass: "ta-c", attrs: { cols: "12" } },
        [
          _c("smart-btn", {
            attrs: {
              to: "/customer/shipments",
              type: "primary",
              label: "Go back to previous page",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }